import { jsx as l } from "react/jsx-runtime";
const o = (a) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentcolor",
        fillRule: "evenodd",
        stroke: "currentcolor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12.75 2.992a1.5 1.5 0 0 1 1.5 1.5v1.41a6.5 6.5 0 0 1 1.9 1.096l1.22-.705a1.5 1.5 0 0 1 2.05.55l.75 1.298a1.5 1.5 0 0 1-.55 2.05l-1.215.701a6.5 6.5 0 0 1 .002 2.201l1.213.7a1.5 1.5 0 0 1 .55 2.05l-.75 1.298a1.5 1.5 0 0 1-2.05.55l-1.208-.698c-.573.477-1.22.85-1.912 1.105v1.394a1.5 1.5 0 0 1-1.5 1.5h-1.5a1.5 1.5 0 0 1-1.5-1.5v-1.394a6.5 6.5 0 0 1-1.912-1.105l-1.208.697a1.5 1.5 0 0 1-2.05-.549l-.75-1.299a1.5 1.5 0 0 1 .55-2.049l1.213-.7a6.5 6.5 0 0 1 .002-2.2L4.38 10.19a1.5 1.5 0 0 1-.55-2.049l.75-1.299a1.5 1.5 0 0 1 2.05-.549l1.22.705a6.5 6.5 0 0 1 1.9-1.096v-1.41a1.5 1.5 0 0 1 1.5-1.5zm-.75 13a4 4 0 1 0 0-8 4 4 0 0 0 0 8",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  o as default
};
